import "./Cards.css";
import React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { selectSavingCard } from "../features/savingCard/savingCardSlice";

const StyledText = styled("text")(({ theme }) => ({
  fill: "#14B084",
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 30,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

const Cards = ({
  title,
  subheading,
  sidesubheading,
  bottomLeftSubheading,
  number,
  button,
  isWhite,
  Icon,
  containsPieChart,
}) => {
  const savingCard = useSelector(selectSavingCard);

  return (
    <div
      className={`flex ${
        isWhite
          ? "bg-white text-[#14B084]"
          : "bg-gradient-to-r from-[#008556] to-[#14B084]"
      } text-white ${!Icon && "w-1/3"} px-2 pb-5 pt-2 rounded-lg justify-center 
    mr-4 flex-col`}
    >
      {Icon && (
        <Icon className={`text-[#14B084] text-7xl mb-4 w-full text-center"}`} />
      )}
      <h3
        className={`card__title ${isWhite && "text-[#14B084]"} ${
          Icon && "text-center mb-5"
        } font-semibold text-3xl mb-1`}
      >
        {title}
      </h3>
      {containsPieChart ? (
        <div className="cards__pieChart">
          <PieChart
            className="card__pieChart"
            series={[
              {
                data: [
                  {
                    value: savingCard?.targetBalance,
                    color: "#14B084",
                    label: "Available",
                  },
                  {
                    value: savingCard?.savingBalance,
                    color: "#008556",
                    label: "Spent",
                  },
                ],
                innerRadius: 60,
                outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                startAngle: -180,
                endAngle: 180,
              },
            ]}
          >
            <PieCenterLabel
              className="text-gray-500
             text-sm font-semibold"
            >
              Goal
            </PieCenterLabel>
          </PieChart>
        </div>
      ) : (
        <>
          <h4
            className={`card__subheading ${isWhite && "text-gray-500"} ${
              Icon && "text-center w-full mt-10"
            } text-sm mb-5 font-semibold`}
          >
            {subheading}
          </h4>

          {!Icon && (
            <h1
              className={`card__number ${
                isWhite && "text-[#14B084]"
              } text-5xl mb-5`}
            >
              ${number}
            </h1>
          )}
        </>
      )}
      <div className="flex flex-row justify-between ">
        <div className="subheadings">
          {sidesubheading && (
            <h4
              className={`card__subheading ${
                isWhite && "text-gray-500"
              }  text-sm font-semibold`}
            >
              {sidesubheading}
            </h4>
          )}
          {bottomLeftSubheading && (
            <h4
              className={`card__subheading ${
                isWhite && "text-gray-500"
              } text-xs font-semibold`}
            >
              {bottomLeftSubheading}
            </h4>
          )}
        </div>
        {!Icon && (
          <button
            className={`card__button ${
              isWhite &&
              "text-white bg-gradient-to-r from-[#008556] to-[#14B084]"
            } bg-[#008556] text-center rounded-2xl text-sm py-2 font-medium ml-auto px-4 `}
          >
            {button}
          </button>
        )}
      </div>
    </div>
  );
};

export default Cards;
